import React, { forwardRef, useEffect, useState } from 'react';

import { MaskedTextField } from '@fluentui/react/lib/TextField';
import getValue from 'components/connectedForm/utils/getValue';

//MaskedTextField in fluentUI does not support null values, so this wrapper hides nulls from the underlying component.
export default forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value || '');

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  const processValue = (event) => {
    const value = getValue(event);
    setValue(value ?? '');

    if (!/\d/.test(value)) {
      //Only use case at this point is a field with numeric values - May need adjusting/re-implementing if this mask input is used for other fields.
      return null;
    } else {
      return value.substring(0, props.mask.length); //For some reason the event has the value but won't have removed the trailing '_' yet :/
    }
  };

  return (
    <MaskedTextField
      {...props}
      ref={ref}
      borderless={true}
      label={null}
      style={{
        ...props.style,
        borderRadius: 0,
        borderBottom: '1px solid lightgray',
        padding: '3px',
      }}
      onChange={(event) => {
        props.onChange(processValue(event));
      }}
      onBlur={(event) => {
        props.onBlur(processValue(event));
      }}
      value={value}
    />
  );
});
